module.exports = __webpack_public_path__ + "static/media/ecosentino-logo-negative.90230309.svg";